
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/procediment-seleccio-direccions-mitjans",
      function () {
        return require("private-next-pages/corporatiu/procediment-seleccio-direccions-mitjans/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/procediment-seleccio-direccions-mitjans"])
      });
    }
  